import { Backdrop, CircularProgress } from "@mui/material";

export default function BackDrop({ open }) {
  return (
    <Backdrop
      open={open}
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <CircularProgress sx={{ color: "#ff7300" }} />
    </Backdrop>
  );
}
